var _ = require('underscore');
var Backbone = require('backbone');


// Reserved master names
var MASTER_MODEL = 'MASTER';
var MASTER_COLLECTION = 'MASTER_COLLECTION';

module.exports = {
  /**
   * Convenience method
   */
  resetState: function() {
    this.setState(this.getInitialState());
  },
  /**
   * When component will be inserted into the dom
   */
  componentWillMount: function() {
    this.setupCoreModels(this.props);
    if (this.setupModels) {
      this.setupModels();
    }
  },

  /**
   * When component is about to receive new props
   */
  componentWillReceiveProps: function(props) {
    this.setupCoreModels(props);
    if (this.setupModels) {
      this.setupModels();
    }
  },

  /**
   * Clean up any model attachments we may have after removing from dom
   */
  componentWillUnmount: function() {
    for (var name in this.models) {
      if (this.models.hasOwnProperty(name)) {
        this.detachModel(name);
      }
    }
  },

  /**
   * Simply ensure we have a models map and handle 'master' data
   * @param {Object} props The props object to use for checking existence of master model/collection
   */
  setupCoreModels: function(props) {
    this.models = this.models || {};

    // Attach master model
    if (props.model) {
      this.model = props.model; // Convenience ref
      this.attachModel(MASTER_MODEL, props.model);
      // Or ensure detachment
    } else {
      this.detachModel(MASTER_MODEL);
      delete this.model; // Remove convenience ref
    }

    // Attach master collection
    if (props.collection) {
      this.collection = props.collection; // Convenience ref
      this.attachModel(MASTER_COLLECTION, props.collection);
      // Or ensure detachment
    } else {
      this.detachModel(MASTER_COLLECTION);
      delete this.collection; // Remove convenience ref
    }
  },

  /**
   * NOOP intended to be overridden by a component where all attachModel calls should be made
   * - This will always be called in the component lifecycle where 'componentWillMount' and
   *   'componentWillReceiveProps' occur.
   */
  /*setupModels: function() {},*/

  /**
   * Attach a model (or collection) to this view under given name. We can then update the view as the model changes.
   * @param  {String} name  The name to store this model under in our models map
   * @param  {Model|Collection} model Model or collection to attach
   * @param  {String} events Custom events string ('change add remove' by default)
   */
  attachModel: function(name, model, events) {
    // If nothing is changing don t do anything
    if (this.models[name] === model) {
      return;
    }

    // Cleanup any existing model under the same name
    if (this.models[name]) {
      this.detachModel(name);
    }

    // Are we actually dealing with an object we can handle? Ie. collection or model
    if (!(model instanceof Backbone.Model || model instanceof Backbone.Collection)) {
      return;
    }

    // Bind to our model and updates
    model.on(events || 'change sync reset', this.onModelUpdate.bind(this, name), this);

    this.models[name] = model;
  },

  /**
   * Detach an attached model
   * @param  {String} name The name we have stored this model under
   */
  detachModel: function(name) {
    if (!this.models[name]) {
      return;
    }

    this.models[name].off(null, null, this);
    delete this.models[name];
  },

  /**
   * Called every time we detect an attached model updates
   */
  onModelUpdate: function() {
    if (this.isMounted()) {
      this.forceUpdate();
    }
  },

  /**
   * Return a class name depending of the validation status
   * @param  {String} name      Name we have stored the model under or attribute if we are using the 'MASTER' model
   * @param  {String} attribute Attribute path in the model
   * @return {String}           A class name
   */
  className: function(name, attribute) {
    var errorsArray = this.getValidation(name, attribute);
    return _.isEmpty(errorsArray) ? 'normalInput' : 'text-warning';
  },

  /**
   * Return an array of errors regarding the given attribute
   * @param  {String} name      Name we have stored the model under or attribute if we are using the 'MASTER' model
   * @param  {String} attribute Attribute path in the model
   * @return {String}           an array of errors
   */
  getModelValidations: function(n, a) {
    var attribute = a;
    var name = n;
    // Allow passing just a attribute name through if we expect a master 'model' on props
    if (!attribute) {
      attribute = name;
      name = MASTER_MODEL;
    }

    return !this.models[name] || this.models[name].isValid() ? [] :
      (_.filter(this.models[name].validationError, function(error) {
        return error.property && (error.property == attribute);
      }));
  },
};



// WEBPACK FOOTER //
// ./app/assets/js/mixins/backbone.js